import styled, { css } from "styled-components";
import { parseCSS } from "scripts/FunctionsBundle";
import NewText from "@components/NewText";
import Breaker from "@components/Breaker";

// ################################ INTERFACES & PROPS ################################

type _Base = import("utils/class-types").Base;
// MainScreen => Rename all instances to use
type MainScreenProps = {} & _Base;

// ################################ RENDERING COMPONENT ################################

const _MainScreen = (props: MainScreenProps) => {
  return (
    <div className={props.className + " screen"}>
      <Breaker _size={"2rem"} />

      <NewText
        _text={`Welcome to |{*}|The Game Codex||! ;;
    |{^:2.5rem}|Here you'll find a variety of |{$:$0}|info||, |{$:$1}|tips|| and |{$:$2}|trivia|| from a selection of games.||`}
        _styleText={{
          _emphasis: {
            _col: ["#2FC69F", "#E3AC14", "#4BD814"],
          },
          _fontSize: {
            _size: ["2.5rem"],
          },
        }}
        _type={"title"}
        _variant={2}
        _align={"center"}
      />

      <div style={{ display: "flex", justifyContent: "center" }}>
        <NewText
          _text={"Go check out the Games List!"}
          _type={"link"}
          _variant={2}
          _this={{
            _link: {
              _to: "/games",
            },
          }}
          _style={{ fontSize: "2rem" }}
          _align={"center"}
        />
      </div>

      <div className={"cards-container"}>
        <div className={"projects-card"}>
          <NewText
            _text={"Legacy"}
            _type={"title"}
            _variant={3}
            _del_margin
            _this={{ _bold: {} }}
          />

          <ol>
            <li>
              <NewText
                _text={"BattleShip!"}
                _type={"link"}
                _this={{
                  _link: { _to: "/projects/battleship" },
                }}
              />
            </li>
            <li>
              <NewText
                _text={"MineSweeper"}
                _type={"link"}
                _this={{
                  _link: { _to: "/projects/minesweeper" },
                }}
              />
            </li>
          </ol>
        </div>

        <div className={"projects-card"}>
          <NewText
            _text={"Game Themed"}
            _type={"title"}
            _variant={3}
            _del_margin
            _this={{ _bold: {} }}
          />

          <ol>
            <li>
              <NewText
                _text={"PvZ: BfN Randomizer"}
                _type={"link"}
                _this={{
                  _link: { _to: "/projects/pvz-randomizer" },
                }}
              />
            </li>
            <li>
              <NewText
                _text={"Games Bingo"}
                _type={"link"}
                _this={{
                  _link: { _to: "/projects/bingo" },
                }}
              />
            </li>
            <li>
              <NewText
                _text={"Pokémon's Type Calculator"}
                _type={"link"}
                _this={{
                  _link: { _to: "/projects/pokemon-calculator" },
                }}
              />
            </li>
            <li>
              <NewText
                _text={"Poké-memorama!"}
                _type={"link"}
                _this={{
                  _link: { _to: "https://pokememorama-taller.netlify.app/" },
                }}
              />
            </li>
          </ol>
        </div>

        <div className={"projects-card"}>
          <NewText
            _text={"Schoolar"}
            _type={"title"}
            _variant={3}
            _del_margin
            _this={{ _bold: {} }}
          />

          <ol>
            <li>
              <NewText
                _text={"JS Compiler"}
                _type={"link"}
                _this={{
                  _link: { _to: "/projects/compiler" },
                }}
              />
            </li>
            <li>
              <NewText
                _text={"Cipher"}
                _type={"link"}
                _this={{
                  _link: { _to: "/projects/cipher" },
                }}
              />
            </li>
            <li>
              <NewText
                _text={"LCR Schedule"}
                _type={"link"}
                _this={{
                  _link: { _to: "/projects/horario-ues" },
                }}
              />
            </li>
          </ol>
        </div>

        <div className={"projects-card"}>
          <NewText
            _text={"Miscellaneous"}
            _type={"title"}
            _variant={3}
            _del_margin
            _this={{ _bold: {} }}
          />
          <ol>
            <li>
              <NewText
                _text={"Music Sheet"}
                _type={"link"}
                _this={{
                  _link: { _to: "/projects/music-sheet" },
                }}
              />
            </li>
            <li>
              <NewText
                _text={"Chess Timer"}
                _type={"link"}
                _this={{
                  _link: { _to: "/projects/chess-timer" },
                }}
              />
            </li>
            <li>
              <NewText
                _text={"Slide Puzzle"}
                _type={"link"}
                _this={{
                  _link: { _to: "/projects/slide-puzzle" },
                }}
              />
            </li>
          </ol>
        </div>

        <div className={"projects-card"}>
          <NewText
            _text={"Other Projects"}
            _type={"title"}
            _variant={3}
            _del_margin
            _this={{ _bold: {} }}
          />
          <ol>
            <li>
              <NewText
                _text={"RSA: Registro de Sacramentos"}
                _type={"link"}
                _this={{
                  _link: { _to: "https://registro-sacramentos.netlify.app/" },
                }}
              />
            </li>
            <li>
              <NewText
                _text={"Enlace Laboratorio: Inicio"}
                _type={"link"}
                _this={{
                  _link: { _to: "https://enlace-laboratorio.com/" },
                }}
              />
            </li>
          </ol>
        </div>
      </div>

      {/* <ul>
        <li>
          <NewText
            _text={"Have any suggestions? Send us an Email!"}
            _type={"link"}
            _this={{
              _link: {
                _to: "/suggestions",
              },
            }}
            _style={{ fontSize: "1.5rem" }}
          />
        </li>

        <li>
          <NewText
            _text={"Need help?"}
            _type={"link"}
            _this={{
              _link: {
                _to: "/help",
              },
            }}
            _style={{ fontSize: "1.5rem" }}
          />
        </li>

        <li>
          <NewText
            _text={"|{_}|RUA Wizard?||"}
            _type={"link"}
            _this={{
              _link: {
                _to: "/admin",
              },
            }}
            _style={{ fontSize: "1.5rem" }}
          />
        </li>
      </ul> */}

      <Breaker />

      <NewText
        _text={`Wanna know me better?;;|{=:https://www.linkedin.com/in/brian-woolfolk-cerecer-3a01162b4/,@:_link-2}|See my CV and contact info!||`}
        _type={"title"}
        _variant={2}
        _align="center"
        _style={{
          backgroundColor: "#a9a9a982",
          backdropFilter: "blur(10px)",
          boxShadow: "0px 0px 20px 0px darkgrey",
        }}
      />

      <Breaker />
    </div>
  );
};

// ################################ STYLES ################################
const MainScreen = styled(_MainScreen).attrs((props): MainScreenProps => {
  return { ...props };
})`
  ${(props) => css`
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
    padding-right: 0;

    ul,
    ol {
      margin-left: 4rem;
      font-size: 2rem;
      font-weight: 700;

      a {
        font-size: inherit;
      }
    }

    li {
      margin: 2rem 0px;
    }

    .cards-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1.5rem;
      padding: 2rem 6rem;
    }

    .projects-card {
    }
    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################

export default MainScreen;
